import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import { usePlacesWidget } from "react-google-autocomplete";
import styles from "./Popup.module.css";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

const AddDriverForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const { register, handleSubmit, control, setValue, setError, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      type: "",
      driver_type: "",
      wage_type: "",
      latitude: "",
      longitude: ""
    }
  });

  const [driverType, setDriverType] = useState("pickup");
  const [selectPCountry, setSelectPCountry] = useState("GB");
  const [selectDCountry, setSelectDCountry] = useState("GH");

  useEffect(() => {
    if (auth?.company && auth?.company?.pickup_country) {
      setSelectPCountry(auth?.company?.pickup_country);
    }
    if (auth?.company && auth?.company?.delivery_country) {
      setSelectDCountry(auth?.company?.delivery_country);
    }
  }, [auth?.company]);

  useEffect(() => {
    if (editData) {
      setValue("type", editData?.type);
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      //setValue("house_no", editData?.house_no);
      setValue("address1", editData?.address);
      setValue("address2", editData?.address);
      setValue("driver_type", editData?.driver_type);
      setValue("wage_type", editData?.wage_type);
      setValue("latitude", editData?.latitude);
      setValue("longitude", editData?.longitude);

      if (parseInt(editData?.type) === 3) {
        setDriverType("pickup");
      }

      if (parseInt(editData?.type) === 4) {
        setDriverType("delivery");
      }
    }
  }, [editData, setValue, auth]);

  const onSubmit = (data) => {
    if (driverType === "pickup") {
      data = { ...data, address: data?.address1, location: selectPCountry };
    } else {
      data = { ...data, address: data?.address2, location: selectDCountry };
    }

    delete data?.address1;
    delete data?.address2;

    setLoading(true);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/drivers/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setFormOpen(false);
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
        if (response.data.status === "VALIDATIONERROR") {
          const serverErrors = response.data.errors;

          // Loop backend validation errors
          Object.keys(serverErrors).forEach((field) => {
            setError(field, {
              type: "server",
              message: serverErrors[field][0], // Laravel style
            });
          });;
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/drivers", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setFormOpen(false);
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
        if (response.data.status === "VALIDATIONERROR") {
          const serverErrors = response.data.errors;

          // Loop backend validation errors
          Object.keys(serverErrors).forEach((field) => {
            setError(field, {
              type: "server",
              message: serverErrors[field][0], // Laravel style
            });
          });;
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  let { ref: ref1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address1", place.formatted_address);
      setValue('latitude', place.geometry.location.lat());
      setValue('longitude', place.geometry.location.lng());
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: selectPCountry },
    },
  });

  const { ref: ref2 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address2", place.formatted_address);
      setValue('latitude', place.geometry.location.lat());
      setValue('longitude', place.geometry.location.lng());
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: selectDCountry },
    },
  });

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      {editData ? "Update Driver" : "Add Driver"}
      <IconButton onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Type*</InputLabel>
              <Controller
                control={control}
                {...register("type", { required: "This field is Required" })}
                render={({ field }) => (
                  <Select
                    label="Type*"
                    {...field}
                    disabled={editData}
                    onChange={(e) => {
                      field.onChange(e);

                      if (e.target.value === 3) {
                        setDriverType("pickup");
                      }

                      if (e.target.value === 4) {
                        setDriverType("delivery");
                      }
                    }}
                  >
                    <MenuItem value={3}>Pickup Driver</MenuItem>
                    <MenuItem value={4}>Delivery Driver</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
            {errors.type && (<span className={`${styles.ErrorM}`}>{errors?.type?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              control={control}
              {...register("name", { required: "This field is Required" })}
              render={({ field }) => (<TextField {...field} label="Full Name*" variant="outlined" fullWidth />)}
            />
            {errors.name && (<span className={`${styles.ErrorM}`}>{errors?.name?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              control={control}
              {...register("email", {
                required: "This field is Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
              render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" disabled={editData} fullWidth />)} />
            {errors.email && (<span className={`${styles.ErrorM}`}>{errors?.email?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              control={control}
              {...register("phone", { required: "This field is Required" })}
              render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" fullWidth />)}
            />
            {errors.phone && (<span className={`${styles.ErrorM}`}>{errors.phone.message}</span>)}
          </div>
          {!editData && (<>
            <div className={`${styles.FormGroupHalf}`}>
              <Controller
                {...register("password", {
                  required: "This field is Required",
                })}
                control={control}
                render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" fullWidth />)}
              />
              {errors.password && (<span className={`${styles.ErrorM}`}>{errors?.password?.message}</span>)}
            </div>
            <div className={`${styles.FormGroupHalf}`}>
              <Controller
                {...register("conf_password", {
                  required: "This field is Required",
                  validate: (val) => {
                    if (watch("password") !== val) {
                      return "Your passwords do no match";
                    }
                  },
                })}
                control={control}
                render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" fullWidth />)}
              />
              {errors.conf_password && (<span className={`${styles.ErrorM}`}>{errors?.conf_password?.message}</span>)}
            </div>
          </>
          )}
          <div className={`${styles.FormGroupFull}`} style={{ display: driverType === "pickup" ? "block" : "none" }}>
            <Controller
              control={control}
              {...register("address1", {
                required: driverType === "pickup" ? true : false,
              })}
              render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={ref1} placeholder="" fullWidth />)}
            />
            {errors.address1 && (<span className={`${styles.ErrorM}`}>This field is Required</span>)}
          </div>

          <div className={`${styles.FormGroupFull}`} style={{ display: driverType === "delivery" ? "block" : "none" }}>
            <Controller
              control={control}
              {...register("address2", {
                required: driverType === "delivery" ? true : false,
              })}
              render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={ref2} placeholder="" fullWidth />)}
            />
            {errors.address2 && (<span className={`${styles.ErrorM}`}>This field is Required</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Driver Type*</InputLabel>
              <Controller
                control={control}
                {...register("driver_type", {
                  required: "This field is Required",
                })}
                render={({ field }) => (<Select label="Driver Type*" {...field}>
                  <MenuItem value="Direct Payroll">Direct Payroll</MenuItem>
                  <MenuItem value="3rd Party Payroll">3rd Party Payroll</MenuItem>
                </Select>)}
              />
            </FormControl>
            {errors.driver_type && (<span className={`${styles.ErrorM}`}>{errors?.driver_type?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Wage Type*</InputLabel>
              <Controller
                control={control}
                {...register("wage_type", { required: "This field is Required" })}
                render={({ field }) => (<Select label="Wage Type*" {...field}>
                  <MenuItem value="Hourly Basis">Hourly Basis</MenuItem>
                  <MenuItem value="Monthly Basis">Monthly Basis</MenuItem>
                </Select>)}
              />
            </FormControl>
            {errors.wage_type && (<span className={`${styles.ErrorM}`}>{errors?.wage_type?.message}</span>)}
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpen(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">{editData ? "Update" : "Add"}</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default AddDriverForm;